import Project from './Project'

export const NON_POWER_PROJECT_TYPES = {
  'Bioheat': {
    'icon': 'flaticon-biomass',
    'key': 'Bioheat',
    'filename': 'geocoded_bioheat_facilities.csv',
    'shortName': 'Bioheat'
  },
  'Geothermal': {
    'icon': 'flaticon-geothermal-energy',
    'key': 'Geothermal',
    'filename': 'geocoded_geothermal_facilities.csv',
    'shortName': 'Geothermal'
  },
  'Incubator': {
    'icon': 'fas fa-lightbulb',
    'key': 'Incubator',
    'filename': 'geocoded_incubators_accelerators.csv',
    'shortName': 'Incubator'
  },
  'Research': {
    'icon': 'fas fa-clipboard',
    'key': 'Research',
    'filename': 'geocoded_research_development.csv',
    'shortName': 'Research'
  },
  'TestCenter': {
    'icon': 'fas fa-flask',
    'key': 'TestCenter',
    'filename': 'geocoded_test_centres_transformed.csv',
    'shortName': 'Test Centre'
  }
}

class OtherProject extends Project {
  static emptyProjectTypes () {
    return JSON.parse(JSON.stringify(NON_POWER_PROJECT_TYPES))
  }

  URL () {
    return `/other-projects/${this.id}`
  }
}

export default OtherProject



// WEBPACK FOOTER //
// ./src/models/OtherProject.js